module.exports = __webpack_public_path__ + "aa76f64fb02058062b2f877cce71d747.svg";